import {
  Tabs,
  Dropdown,
  Select,
  Tooltip,
  Input,
  Modal,
  Button,
  Form,
  message,
  DatePicker,
  Space,
} from "antd";
import React, { forwardRef, useEffect, useState, useRef } from "react";
import {
  MenuOutlined,
  FileAddOutlined,
  HistoryOutlined,
  EditOutlined,
  PlusOutlined,
  FormOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import UploadFile from "@/components/UplaodFile";
// import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import {
  CustomTable,
  CustomTableExtend,
  FileDetail,
  CustomUpload,
  CustomModal,
} from "@/hocComponents";
import AddModal from "./components/LastPaymentModal";
import PropDetailModal from "./components/PropDetailModal";

const MainTable = forwardRef((props, ref) => {
  const [currentRecord, setCurrentRecord] = useState(null);
  const [propTypeList, setPropTypeList] = useState([]);
  const [glAcctList, setGlAcctList] = useState([]);
  const [addopen, setAddOpen] = useState(false);
  const [uploadDisabled, setUploadDisabled] = useState(false);
  const initTableHead = {
    prop: null,
    addressCityState: null,
    propType: null,
    units: null,
    purDate: null,
    grossRentReceived: null,
    expirationDateStr: null,
    lastPayment: null,
    licenseType: null,
    businessLicenseNumber: null,
    vendorName: null,
    businessName: null,
    pin: null,
    status: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);
  const [addRecord, setAddRecord] = useState(null);
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: 200,
    });
  };

  const paymentColumns = () => {
    return [0, 1, 2].map(item => ({
      title: 'Last Payment',
      dataIndex: `lastPayment_${item}`,
      width: 120,
      onCell: () => ({
        style: {
          padding: "8px",
        },
      }),
      render: (text, record) => {
        const { latestPayments } = record
        const payment = (latestPayments || [])[item]
        if (!payment) return <div>-</div>;
        const { amount, paymentColor, paymentDate } = payment
        const colorMatch = {
          0: "#3c8dbc",
          1: "#dd4b39",
          2: "green",
          3: "#f39c12",
        };
        const titleMatch = {
          0: "(Pending)",
          1: "(Not Cash)",
          2: "(Cashed)",
          3: "(Voided)",
        };

        const textColor = colorMatch[paymentColor] || "";
        const title = titleMatch?.[paymentColor] || "";
  
        return (
          <div
            style={{ color: textColor, cursor: "pointer" }}
            onClick={() => handleCellClick(payment, true)}
          >
            {(title && (
              <span
                style={{
                  borderBottom: `1px dashed ${textColor}`,
                  paddingBottom: "2px",
                }}
              >
                {title}
              </span>
            )) ||
              null}
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {paymentDate
                ? moment(paymentDate).format("MM/DD/YYYY")
                : "-"}
            </span>
            <br />
            <span
              style={{
                borderBottom: `1px dashed ${textColor}`,
                paddingBottom: "2px",
              }}
            >
              {amount
                ? new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 2,
                  }).format(parseFloat(amount))
                : "-"}
            </span>
          </div>
        );
      },
    }))
  }

  const initColumns = [
    {
      title: "Action",
      dataIndex: "viewDetail",
      titleType: "",
      width: 60,
      render: (text, record) =>
        ((commonFn.btnAuthorityFlag("ViewPropDetail") ||
          commonFn.btnAuthorityFlag("EditBusinessLicense") ||
          commonFn.btnAuthorityFlag("UpdateExpirationDate") ||
          commonFn.btnAuthorityFlag("MakePayment") ||
          commonFn.btnAuthorityFlag("DocumentHistory") ||
          commonFn.btnAuthorityFlag("Update Status") ||
          commonFn.btnAuthorityFlag("Delete")) && (
          <Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag("ViewPropDetail") && {
                  key: "View Propety Detail",
                  icon: <EditOutlined twoToneColor="#1677FF" />,
                  label: <div>View Propety Detail</div>,
                },
                commonFn.btnAuthorityFlag("EditBusinessLicense") && {
                  key: "Edit Business License",
                  icon: <EditOutlined twoToneColor="#1677FF" />,
                  label: <div>Edit Business License</div>,
                },
                commonFn.btnAuthorityFlag("UpdateStatus") && {
                  key: "Update Status",
                  icon: <HistoryOutlined twoToneColor="#1677FF" />,
                  label: <div>Update Status</div>,
                },
                commonFn.btnAuthorityFlag("UpdateExpirationDate") && {
                  key: "Update Expiration Date",
                  icon: <FileAddOutlined twoToneColor="#1677FF" />,
                  disabled: !record?.id,
                  label: <div>Update Expiration Date</div>,
                },
                commonFn.btnAuthorityFlag("MakePayment") && {
                  key: "Make Payment",
                  icon: <FormOutlined twoToneColor="#1677FF" />,
                  disabled: !record?.id,
                  label: <div>Make Payment</div>,
                },
                commonFn.btnAuthorityFlag("DocumentHistory") && {
                  key: "Document History",
                  icon: <HistoryOutlined twoToneColor="#1677FF" />,
                  disabled: !record?.id,
                  label: <div>Expiration Certificate</div>,
                },
                commonFn.btnAuthorityFlag("Delete") && {
                  key: "Delete",
                  icon: <HistoryOutlined twoToneColor="#1677FF" />,
                  disabled: !record?.id,
                  label: <div>Delete</div>,
                },
              ],
              onClick: (e) => handleDetailClick(e.key, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined className="col-blue" />
          </Dropdown>
        )) ||
        null,
    },
    {
      title: "Prop",
      dataIndex: "prop",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "prop"),
    },
    {
      title: "Address City State",
      dataIndex: "addressCityState",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "addressCityState"),
    },
    {
      title: "Prop Type - Unit",
      dataIndex: "propType",
      titleType: "Select",
      isSorter: true,
      width: 150,
      sortterMultiple: 3,
      selectOptions: propTypeList,
      onChange: (e) => tableFilterFn(e, "propType", "Select"),
    },
    {
      title: "Gross Rent Received",
      dataIndex: "grossRentReceived",
      titleType: "",
      isSorter: true,
      sortterMultiple: 3,
      isAmountFlag: true,
      onChange: (e) => tableFilterFn(e, "grossRentReceived"),
      render: (text) => {
        if (!text && text != 0) return "-"; // 处理空值
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(text);
      },
    },
    {
      title: "Expiration Date",
      dataIndex: "expirationDateStr",
      titleType: "RangePicker",
      isSorter: false,
      sortterMultiple: 3,
      onChange: (e) =>
        tableFilterFn(
          e,
          ["sExpirationDateStr", "eExpirationDateStr"],
          "RangePicker"
        ),
      render: (text, record) => {
        if (text !== "Pending") return text;
        return (
          <span
            onClick={() => getViewDocumentFn(record.id)}
            style={{
              color: "#3c8dbc",
              borderBottom: `1px dashed #3c8dbc`,
              paddingBottom: "2px",
              cursor: "pointer",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "vendorName"),
    },
    {
      title: "License Type",
      dataIndex: "licenseType",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "licenseType"),
    },
    ...paymentColumns(),
    {
      title: "Business License #",
      dataIndex: "businessLicenseNumber",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      width: 120,
      onChange: (e) => tableFilterFn(e, "businessLicenseNumber"),
    },
    {
      title: "Pin",
      dataIndex: "pin",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "pin"),
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: "Select",
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        {
          label: "Required",
          value: "Required",
        },
        {
          label: "Not Required",
          value: "Not Required",
        },
      ],
      onChange: (e) => tableFilterFn(e, "status", "Select"),
    },
  ];

  const customModalRef = useRef(null);
  const propDetailModalRef = useRef(null);

  const handleDetailClick = (key, record) => {
    if (key === "Document History") {
      getDocumentHistoryDetailFn(record?.id || 0);
      return;
    }
    setCurrentRecord(record);
    if (key === "Edit Business License") {
      if (record?.vendorId) {
        setVendorList([
          {
            label: record.vendorNameAdd,
            value: record.vendorId,
          },
        ]);
      } else {
        vendorIdFn();
      }
      openAddModalFn();
      const {
        propId,
        vendorId,
        businessLicenseNumber,
        businessName,
        owner,
        pin,
        licenseTypeId,
        status,
      } = record;
      form.setFieldsValue({
        propId,
        vendorId,
        businessLicenseNumber,
        businessName,
        owner,
        pin,
        licenseTypeId,
        status,
        isUpload: false,
      });
    }
    if (key === "Update Expiration Date") {
      form1.setFieldsValue({
        businessLicenseNumber: record?.businessLicenseNumber,
      });
      setUpdateModalLoading(false);
      setUEDModalFlag(true);
    }
    if (key === "Make Payment") {
      setBLPModalLoading(false);
      setBLPModalFlag(true);
    }
    if (key === "Update Status") {
      setUpdateStatusLoading(false);
      setUSModalFlag(true);
    }
    if (key === "Delete") {
      customModalRef.current.openModalFn();
    }
    if (key === "View Propety Detail") {
      propDetailModalRef.current.openModal({
        modalName: 'View Property Detail',
        propId: record?.propId
      });
    } 
  };

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 200,
    total: 0,
  });

  const location = useLocation();
  const [headTypeKey, setHeadTypeKey] = useState(null);
  const [idsList, setIdsList] = useState([]);

  const headTypeKeyFn = (key) => {
    const url = `${window.location.origin}#/AccountPayable/BusinessLicense?headType=${key}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    const query = new URLSearchParams(location.search);
    const headType = Object.fromEntries(query.entries())?.headType || null;
    const ids = Object.fromEntries(query.entries())?.ids || [];
    setHeadTypeKey(headType);
    setIdsList(ids);
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      headType,
      ids,
    };
    const response = await http.get(api.businessLicenseShow, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
  };
  const [totalDetail, setTotalDetail] = useState({});

  const businessLicenseGetHeadFn = async () => {
    const response = await http.get(api.businessLicenseGetHead);
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    setTotalDetail(response?.data || {});
  };

  const getDictionaryFn = async () => {
    const response = await http.get(api.getDictionary, {
      params: {
        type: "util_payment",
        value: "propType",
      },
    });
    setPropTypeList(response);
  };

  const getGlAcctListFn = async () => {
    const response = await http.get(api.businessLicenseGlAcctList);
    const temp = (response?.data || [])?.map((item) => ({
      label: item.glAcctTitle,
      value: item.glAcct,
    }));
    setGlAcctList(temp);
  };

  const handleCellClick = async (record, flag = false) => {
    const response = await http.get(api.commonShowPayment, {
      params: {
        vendorPaymentId: record.paymentId,
      },
    });
    const val = response.code === "1" ? response.data : {};
    const invoiceDateTemp = dayjs(flag ? val.invoiceDate : new Date());
    setAddRecord({
      ...record,
      ...val,
      invoiceDate: invoiceDateTemp,
      amount: val?.amount || 0,
      serviceStartDate:
        (val?.serviceStartDate && dayjs(val?.serviceStartDate)) || null,
      serviceEndDate:
        (val?.serviceEndDate && dayjs(val?.serviceEndDate)) || null,
      invoiceTenant: String(val.invoiceTenant),
      foreignId: val?.foreignId || record?.vendorUtilPaymentId,
      paymentId: record?.paymentId,
      filePaths: val?.filePaths || [],
      isEdit: flag,
      noSubmitBtn: true,
      usid: val?.usid,
    });
    setAddOpen(true);
  };

  useEffect(() => {
    businessLicenseGetHeadFn();
    getDictionaryFn();
    getGlAcctListFn()
  }, []);

  useEffect(() => {
    if (propTypeList?.length) {
      setColumns(initColumns);
    }
  }, [propTypeList]);

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 200);
  }, [refreshKey]);

  const [form] = Form.useForm();
  const [addModalFlag, setAddModalFlag] = useState(false);
  const [propIdList, setPropIdList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [licenseTypeIdList, setLicenseTypeIdList] = useState([]);
  const [isUploadFlag, setIsUploadFlag] = useState(false);
  const [addModalLoading, setAddModalLoading] = useState(false);
  const uploadFileRef = useRef();

  const openAddModalFn = (flag) => {
    if (flag) {
      propIdFn();
      vendorIdFn();
    }
    licenseTypeIdFn();
    setAddModalFlag(true);
  };

  const addBusinessLicenseFn = async (values) => {
    setAddModalLoading(true);
    const response = await http.post(api.addBusinessLicense, {
      ...values,
      id: currentRecord?.id || undefined,
      expirationDateStr:
        (values?.expirationDate &&
          values.expirationDate.format("YYYY-MM-DD")) ||
        "",
    });
    if (response.code === "1") {
      message.success("New successfully");
      addBusinessLicenseCancelFn();
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setAddModalLoading(false);
  };

  const addBusinessLicenseCancelFn = () => {
    setCurrentRecord(null);
    setVendorList([]);
    form.resetFields();
    setIsUploadFlag(false);
    setAddModalFlag(false);
    setIsNoRequired(false);
  };

  const propIdFn = async (content = "") => {
    const response = await http.get(api.propSearch, { params: { content } });
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.propId,
        label: item.propName,
      }));
      setPropIdList(list);
    }
  };

  const vendorIdFn = async (content = "") => {
    const response = await http.get(api.vendorSearch, { params: { content } });
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));
      setVendorList(list);
    }
  };

  const licenseTypeIdFn = async (content = "") => {
    const response = await http.get(api.getShowVo, { params: { content } });
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.id,
        label: item.businessTypeRemark,
      }));
      setLicenseTypeIdList(list);
    }
  };

  const addUpload = async (data, key) => {
    setUploadDisabled(true);
    const formMatch = {
      form: form,
      form1: form1,
      form2: form2,
      form3: form3,
    };
    const uploadedFiles = await uploadFiles(data);
    formMatch[key].setFieldsValue({ filePaths: uploadedFiles });
    setUploadDisabled(false);
  };

  const uploadFiles = async (data) => {
    const files = [];
    for (const item of data) {
      const formData = new FormData();
      formData.append("files", item.originFileObj);
      const response = await http.post(api.UploadFile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.code === "1") {
        const result = response.data;
        files.push(result[0]);
      }
    }
    return files;
  };

  useEffect(() => {
    if (isUploadFlag) {
      form.setFieldsValue({
        expirationDate: null,
        filePaths: null,
      });
    }
  }, [isUploadFlag]);

  // 更新
  const [form1] = Form.useForm();
  const uploadFileRef1 = useRef();
  const [UEDModalFlag, setUEDModalFlag] = useState(false);
  const [updateModalLoading, setUpdateModalLoading] = useState(false);
  const [isNoRequired, setIsNoRequired] = useState(false);

  const updateBusinessLicenseCancelFn = () => {
    form1.resetFields();
    setCurrentRecord(null);
    setUEDModalFlag(false);
  };

  const updateBusinessLicenseFn = async (values) => {
    setUpdateModalLoading(true);
    const response = await http.post(api.updateExpirationDate, {
      ...values,
      id: currentRecord.id,
      expirationDateStr:
        (values?.expirationDate &&
          values.expirationDate.format("YYYY-MM-DD")) ||
        "",
    });
    if (response.code === "1") {
      message.success("Update Expiration Date successfully");
      updateBusinessLicenseCancelFn();
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setUpdateModalLoading(false);
  };

  // 推送账单
  const [form2] = Form.useForm();
  const uploadFileRef2 = useRef();
  const [BLPModalFlag, setBLPModalFlag] = useState(false);
  const [BLPModalLoading, setBLPModalLoading] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);

  useEffect(() => {
    if (BLPModalFlag) {
      form2.setFieldsValue({
        filePaths: filePaths,
      });
    }
    if (USModalFlag) {
      form3.setFieldsValue({
        filePaths: filePaths,
      });
    }
  }, [filePaths]);

  const BLPaymentCancelFn = () => {
    form2.resetFields();
    setCurrentRecord(null);
    setBLPModalFlag(false);
  };

  const BLPaymentFn = async (values) => {
    setBLPModalLoading(true);
    const response = await http.post(api.businessLicenseMakePayment, {
      ...values,
      penalty: values?.penalty || 0,
      otherFee: values?.otherFee || 0,
      uuidList: filePaths.map((item) => item.uuid),
      id: currentRecord.id,
    });
    if (response.code === "1") {
      message.success("Send to Approval Request successfully");
      BLPaymentCancelFn();
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setBLPModalLoading(false);
  };

  const [DCModalFlag, setDCModalFlag] = useState(false);
  const [DCFileList, setDCFileList] = useState([]);

  const DCCancelFn = () => {
    setDCModalFlag(false);
    setDCFileList([]);
  };

  const getDocumentHistoryDetailFn = async (id) => {
    const response = await http.get(api.businessLicenseDocumentHistory, {
      params: { id },
    });
    if (response?.code === "1") {
      setDCFileList(response.data);
      setDCModalFlag(true);
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  const [form3] = Form.useForm();
  const [USModalFlag, setUSModalFlag] = useState(false);
  const [updateStatusLoading, setUpdateStatusLoading] = useState(false);
  const uploadFileRef3 = useRef(null);

  const USCancelFn = () => {
    form3.resetFields();
    setCurrentRecord(null);
    setUSModalFlag(false);
  };

  const updateStatusSubmitFn = async (values) => {
    setUpdateStatusLoading(true);
    const response = await http.post(api.businessLicenseUpdateStatus, {
      id: currentRecord?.id || undefined,
      propId: currentRecord?.propId || undefined,
      expirationStatus: 2,
      pendingReason: values?.pendingReason,
      filePaths: values.filePaths,
    });
    if (response?.code === "1") {
      USCancelFn();
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    } else {
      commonFn.modalFailedFn(response);
    }
    setUpdateStatusLoading(false);
  };

  const [VDModalFlag, setVDModalFlag] = useState(false);
  const [VDFileList, setVDFileList] = useState([]);

  const VDCancelFn = () => {
    setVDModalFlag(false);
    setVDFileList([]);
  };

  const getViewDocumentFn = async (id) => {
    const response = await http.get(api.businessLicenseShowPendingFile, {
      params: { id },
    });
    if (response?.code === "1") {
      setVDFileList(response.data);
      setVDModalFlag(true);
    } else {
      commonFn.modalFailedFn(response);
    }
  };

  useEffect(() => {
    if (USModalFlag) {
      updateStatusOpenFn();
    }
  }, [USModalFlag]);

  const updateStatusOpenFn = async () => {
    const { id } = currentRecord;
    if (!id) return;
    setUpdateStatusLoading(true);
    const response = await http.get(api.businessLicenseShowInvoice, {
      params: { id },
    });
    if (response.code === "1") {
      form3.setFieldsValue({
        pendingReason: response?.data?.pendingReason,
      });
    } else {
      message.error(response.msg || "Failed to fetch user data");
    }
    setUpdateStatusLoading(false);
  };

  const downLoadFn = async () => {
    const blob = await http.get(api.exportBusinessLicenseExcel, {
      params: { ...tableHead, headType: headTypeKey, ids: idsList },
      responseType: "blob",
    });
    return {
      blob,
      name: `BusinessLicense`,
    };
  };

  const deleteFn = async () => {
    const response = await http.get(api.businessLicenseDelete, {
      params: {
        id: currentRecord?.id,
        propId: currentRecord?.propId,
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getTableListFn(pagination.current, pagination.pageSize, { ...tableHead });
    } else {
      commonFn.modalFailedFn(response);
    }
    setCurrentRecord(null);
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[
          !commonFn.btnAuthorityFlag("Download") && "download",
          (headTypeKey || idsList?.length) && "UserUsage",
        ]}
        downLoadFn={() => downLoadFn()}
      >
        <div className="topLeft">
          {(commonFn.btnAuthorityFlag("New") &&
            !(headTypeKey || idsList?.length) && (
              <Space size="large">
                <Button className="btnNew" onClick={openAddModalFn}>
                  <PlusOutlined />
                  New
                </Button>
              </Space>
            )) ||
            null}
          {[
            {
              bgColor: "#16ffd4",
              name: "Pending: ",
              nameKey: "pending",
              headType: "pending",
              authKey: "pending",
            },
            {
              bgColor: "#FA8A05",
              name: "No Expiration Date: ",
              nameKey: "noExpirationDate",
              headType: "noExpiration",
              authKey: "noExpirationDate",
            },
            {
              bgColor: "#FCDC05",
              name: "Expired: ",
              nameKey: "expired",
              headType: "expired",
              authKey: "expired",
            },
            {
              bgColor: "#6de3d2",
              name: "Expiring Less Than 15 days: ",
              nameKey: "expiringLessThan15Days",
              headType: "expiring15",
              authKey: "expiringLessThan15Days",
            },
            {
              bgColor: "#97E1AE",
              name: "Not Required License: ",
              nameKey: "notRequiredLicense",
              headType: "notRequired",
              authKey: "notRequiredLicense",
            },
            {
              bgColor: "#f9000069",
              name: "Not Cash More Than 15 Days: ",
              nameKey: "notCashMoreThan15",
              headType: "notCashMoreThan15",
              authKey: "notCashMoreThan15",
            },
          ].map((item) => (
            <commonFn.BtnAuthorityFn authKey={item.authKey}>
              <span
                style={{
                  fontSize: 15,
                  marginLeft: 20,
                  padding: "6px 6px",
                  borderRadius: "5px",
                  cursor: headTypeKey ? "unset" : "pointer",
                  backgroundColor: item.bgColor,
                  // display: ((headTypeKey && headTypeKey !== item.headType) || idsList?.length) ? 'none' : undefined
                  display:
                    (headTypeKey && headTypeKey !== item.headType) ||
                    idsList?.length
                      ? "none"
                      : "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => !headTypeKey && headTypeKeyFn(item.headType)}
              >
                {item.name} {totalDetail[item.nameKey]}
              </span>
            </commonFn.BtnAuthorityFn>
          ))}
        </div>
      </CustomTableExtend>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <Modal
        title={currentRecord?.id || currentRecord?.propId ? "Edit" : "New"}
        width="50%"
        maskClosable={false}
        open={addModalFlag}
        onCancel={addBusinessLicenseCancelFn}
        footer={[
          <Button key="back" onClick={addBusinessLicenseCancelFn}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={addModalLoading}
            disabled={uploadDisabled}
            onClick={() => form.submit()}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          form={form}
          initialValues={{
            isUpload: false,
          }}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          onFinish={addBusinessLicenseFn}
          validateMessages={{
            required: "${label} is required!",
          }}
        >
          <Form.Item
            name="propId"
            label="Property"
            rules={[{ required: true }]}
            style={{
              display: currentRecord?.id || currentRecord?.propId ? "none" : "",
            }}
          >
            <Select
              showSearch
              allowClear
              onSearch={propIdFn}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={propIdList}
            />
          </Form.Item>

          <Form.Item
            name="vendorId"
            label="Vendor"
            rules={[{ required: isNoRequired }]}
          >
            <Select
              showSearch
              allowClear
              onSearch={vendorIdFn}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={vendorList}
            />
          </Form.Item>

          <Form.Item
            name="businessLicenseNumber"
            label="Business License #"
            rules={[
              {
                required: isNoRequired,
                message: "Business License # is required!",
              },
            ]}
          >
            <Input placeholder="Please input Business License #" />
          </Form.Item>

          <Form.Item name="businessName" label="Business Name">
            <Input placeholder="Please input Business Name" />
          </Form.Item>

          {(currentRecord?.id && (
            <Form.Item name="owner" label="Owner">
              <Input disabled placeholder="Please input Owner" />
            </Form.Item>
          )) ||
            null}

          <Form.Item name="pin" label="Pin">
            <Input placeholder="Please input Pin" />
          </Form.Item>

          <Form.Item
            name="licenseTypeId"
            label="License Type (Class)"
            rules={[{ required: isNoRequired }]}
          >
            <Select
              allowClear
              onSearch={licenseTypeIdFn}
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={licenseTypeIdList}
            />
          </Form.Item>

          <Form.Item name="status" label="Status">
            <Select
              allowClear
              onChange={(e) => setIsNoRequired(e === "Required")}
              optionFilterProp="label"
              options={[
                {
                  label: "Required",
                  value: "Required",
                },
                {
                  label: "Not Required",
                  value: "Not Required",
                },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="isUpload"
            label="Update Expiration Date"
            rules={[
              {
                required: true,
                message: "Update Expiration Date is required!",
              },
            ]}
          >
            <Select
              allowClear
              optionFilterProp="label"
              onChange={(e) => setIsUploadFlag(e)}
              options={[
                {
                  label: "Yes",
                  value: true,
                },
                {
                  label: "No",
                  value: false,
                },
              ]}
            />
          </Form.Item>

          {(isUploadFlag && (
            <>
              <Form.Item
                name="expirationDate"
                label="Expiration Date"
                rules={[
                  { required: true, message: "Expiration Date is required!" },
                ]}
              >
                <DatePicker
                  style={{ width: "100%" }}
                  format="MM/DD/YYYY"
                  getPopupContainer={(trigger) => trigger.parentElement}
                />
              </Form.Item>
              <Form.Item
                name="filePaths"
                label="Upload License Certificate"
                rules={[
                  {
                    required: true,
                    message: "License Certificate is required!",
                  },
                ]}
              >
                <UploadFile
                  ref={uploadFileRef}
                  sendDataToParent={(data) => addUpload(data, "form")}
                />
              </Form.Item>
            </>
          )) ||
            null}
        </Form>
      </Modal>

      <Modal
        title="Update Expiration Date"
        width="50%"
        maskClosable={false}
        open={UEDModalFlag}
        onCancel={updateBusinessLicenseCancelFn}
        footer={[
          <Button key="back" onClick={updateBusinessLicenseCancelFn}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={updateModalLoading}
            disabled={uploadDisabled}
            onClick={() => form1.submit()}
          >
            Update Expiration Date
          </Button>,
        ]}
      >
        <Form
          form={form1}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          onFinish={updateBusinessLicenseFn}
          validateMessages={{
            required: "${label} is required!",
          }}
        >
          <Form.Item
            name="businessLicenseNumber"
            label="Business License #"
            rules={[
              { required: true, message: "Business License # is required!" },
            ]}
          >
            <Input placeholder="Please input Business License #" />
          </Form.Item>
          <Form.Item
            name="expirationDate"
            label="Expiration Date"
            rules={[
              { required: true, message: "Expiration Date is required!" },
            ]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
          <Form.Item
            name="filePaths"
            label="Upload License Certificate"
            rules={[
              { required: true, message: "License Certificate is required!" },
            ]}
          >
            <UploadFile
              ref={uploadFileRef1}
              sendDataToParent={(data) => addUpload(data, "form1")}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Business License Payment"
        width="50%"
        maskClosable={false}
        open={BLPModalFlag}
        onCancel={BLPaymentCancelFn}
        footer={[
          <Button key="back" onClick={BLPaymentCancelFn}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={BLPModalLoading}
            disabled={btnDisabled}
            onClick={() => form2.submit()}
          >
            Send to Approval Request
          </Button>,
        ]}
      >
        <Form
          form={form2}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          onFinish={BLPaymentFn}
          onValuesChange={(_, all) => {
            const toCents = (v) => {
              const n = Number(v ?? 0);
              return parseInt(n.toFixed(2).replace(".", ""), 10) || 0;
            };
            const totalCents =
              toCents(all.licenseAmount) +
              toCents(all.penalty) +
              toCents(all.otherFee);
            form2.setFieldsValue({ total: totalCents / 100 });
          }}
          validateMessages={{
            required: "${label} is required!",
          }}
        >
          {commonFn.formInputNumberDoc({
            name: "licenseAmount",
            label: "License Amount",
            form: form2,
          })}

          {commonFn.formInputNumberDoc({
            name: "penalty",
            label: "Penalty",
            form: form2,
            isNoRequired: true,
          })}

          {commonFn.formInputNumberDoc({
            name: "otherFee",
            label: "Other Fee",
            form: form2,
            isNoRequired: true,
          })}

          {commonFn.formInputNumberDoc({
            name: "total",
            label: "Total",
            form: form2,
            disabled: true,
            isNoRequired: true,
          })}

          <Form.Item
            name="glAcct"
            label="GL Account"
            rules={[{ required: true, message: "GL Account is required!" }]}
          >
            <Select
              showSearch
              style={{ width: "100%" }}
              placeholder="Please select GL Account"
              options={glAcctList}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <Form.Item
            name="filePaths"
            label="Upload Payment Document"
            rules={[
              { required: true, message: "Payment Document is required!" },
            ]}
          >
            <CustomUpload
              setFilePaths={setFilePaths}
              filePaths={filePaths}
              setBtnDisabled={setBtnDisabled}
              btnDisabled={btnDisabled}
              isEdit={false}
              vendorPaymentId={currentRecord?.vendorPaymentId || undefined}
              foreignId={currentRecord?.id || undefined}
              type={"businessLicense"}
              customConfig={{
                accept: ".jpg, .jpeg, .png, .pdf",
                disabled: currentRecord?.noSubmitBtn || false,
                noShowFile: true,
              }}
            />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Document History"
        width="50%"
        maskClosable={false}
        open={DCModalFlag}
        onCancel={DCCancelFn}
        footer={false}
      >
        <FileDetail
          urlKey="url"
          nameKey="fileName"
          fileList={DCFileList || []}
        />
      </Modal>

      <Modal
        title="Update Status"
        width="50%"
        maskClosable={false}
        open={USModalFlag}
        onCancel={USCancelFn}
        footer={[
          <Button key="back" onClick={USCancelFn}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={updateStatusLoading}
            disabled={uploadDisabled}
            onClick={() => form3.submit()}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          form={form3}
          initialValues={{
            expirationDate: "Pending",
          }}
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          onFinish={updateStatusSubmitFn}
          validateMessages={{
            required: "${label} is required!",
          }}
        >
          <Form.Item
            name="expirationDate"
            label="Expiration Date"
            rules={[{ required: true }]}
          >
            <Input disabled placeholder="Please Input Expiration Date" />
          </Form.Item>

          <Form.Item
            name="pendingReason"
            label="Pending Reason"
            rules={[{ required: true }]}
          >
            <Input.TextArea
              disabled={updateStatusLoading}
              placeholder="Please Input Pending Reason"
              autoSize={{ minRows: 3, maxRows: 10 }}
            />
          </Form.Item>

          <Form.Item
            name="filePaths"
            label="Pending Document"
            rules={[
              { required: true, message: "Pending Document is required!" },
            ]}
          >
            <UploadFile
              ref={uploadFileRef3}
              sendDataToParent={(data) => addUpload(data, "form3")}
            />
          </Form.Item>
 
        </Form>
      </Modal>

      <Modal
        title="View Document"
        width="50%"
        maskClosable={false}
        open={VDModalFlag}
        onCancel={VDCancelFn}
        footer={false}
      >
        <FileDetail
          urlKey="url"
          nameKey="fileName"
          fileList={VDFileList || []}
        />
      </Modal>

      {/* 点击金额 新增弹窗 */}
      <AddModal
        addopen={addopen}
        form={form}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />
      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          deleteContent: "business license",
          onOkFn: deleteFn,
        }}
      />

      <PropDetailModal
        ref={propDetailModalRef}
        // submitInitFn={submitInitFn}
      />
    </div>
  );
});
export default MainTable;
